/**
 * Burger Menu Animation Handler
 * Adds active class toggle for burger menu animation
 */

document.addEventListener('DOMContentLoaded', function() {
    const burgerMenu = document.querySelector('.burger-menu');
    const navbarCollapse = document.querySelector('#navbar');
    
    if (!burgerMenu || !navbarCollapse) return;
    
    // Handle burger menu toggle - removed to avoid conflict with Bootstrap
    // Bootstrap's aria-expanded attribute will handle the state
    
    // Listen for Bootstrap collapse events
    navbarCollapse.addEventListener('shown.bs.collapse', function() {
        burgerMenu.classList.add('active');
        burgerMenu.setAttribute('aria-expanded', 'true');
    });
    
    navbarCollapse.addEventListener('hidden.bs.collapse', function() {
        burgerMenu.classList.remove('active');
        burgerMenu.setAttribute('aria-expanded', 'false');
    });
    
    // Listen for show/hide events (these fire before shown/hidden)
    navbarCollapse.addEventListener('show.bs.collapse', function() {
        burgerMenu.classList.add('active');
        burgerMenu.setAttribute('aria-expanded', 'true');
    });
    
    navbarCollapse.addEventListener('hide.bs.collapse', function() {
        burgerMenu.classList.remove('active');
        burgerMenu.setAttribute('aria-expanded', 'false');
    });
    
    // Ensure proper state on page load
    if (navbarCollapse.classList.contains('show')) {
        burgerMenu.classList.add('active');
        burgerMenu.setAttribute('aria-expanded', 'true');
    } else {
        burgerMenu.classList.remove('active');
        burgerMenu.setAttribute('aria-expanded', 'false');
    }
});